/**
 * Open state for a popover that opens while the mouse is over its anchor or
 * its content, with a short grace period to cross the gap between them.
 * Bind `onPointerEnter`/`onPointerLeave` on both. Touch and keyboard never
 * hover, so the anchor itself should still lead somewhere when activated.
 */
export function useHoverMenu(closeDelay = 150) {
  const open = ref(false)
  let closeTimer: ReturnType<typeof setTimeout> | undefined

  function onPointerEnter(e: PointerEvent) {
    if (e.pointerType !== 'mouse') return
    clearTimeout(closeTimer)
    open.value = true
  }

  function onPointerLeave(e: PointerEvent) {
    if (e.pointerType !== 'mouse') return
    clearTimeout(closeTimer)
    closeTimer = setTimeout(() => {
      open.value = false
    }, closeDelay)
  }

  function close() {
    clearTimeout(closeTimer)
    open.value = false
  }

  onBeforeUnmount(() => clearTimeout(closeTimer))

  return { open, onPointerEnter, onPointerLeave, close }
}
